// extracted by mini-css-extract-plugin
module.exports = {"AnswersList":"_1WLwoxjPnsas3voYqldH7I"};